export default __webpack_public_path__ + "static/cs-solution-architecture-3d8ca065aaed371f9641c092c051b410.webp";